import { Link } from "wouter";
import type { PersonSummary } from "../lib/queries";
import type { Activity } from "../lib/format";
import { useT } from "../lib/i18n";
import { Avatar } from "./Avatar";
import { ActivityList } from "./ui";

/** One person in a followers / following list. */
export function PersonRow({ person }: { person: PersonSummary }) {
  const { t } = useT();
  const activities = (person.activities ?? []) as Activity[];
  return (
    <Link
      href={`/person/${person.id}`}
      className="flex items-center gap-3 rounded-xl border bg-card p-3 text-card-foreground shadow-card transition-all duration-150 hover:border-muted-foreground/30 hover:shadow-card-hover"
    >
      <Avatar person={person} />
      <div className="min-w-0">
        <p className="truncate font-semibold tracking-tight">
          {person.displayName || t("common.unnamed")}
        </p>
        {activities.length > 0 && (
          <p className="mt-0.5 truncate text-sm text-muted-foreground">
            <ActivityList activities={activities} />
          </p>
        )}
      </div>
    </Link>
  );
}
